var map = {
	"./0/Kambi/SecondaryMenu.layout.js": [
		8017,
		9539,
		3879
	],
	"./0/Poker/SecondaryMenu.layout.js": [
		4131,
		9539,
		8625
	],
	"./0/Spectate/SecondaryMenu.layout.js": [
		33790,
		9539,
		6246
	],
	"./1/Kambi/SecondaryMenu.layout.js": [
		21623,
		1450
	],
	"./1/Poker/SecondaryMenu.layout.js": [
		83330,
		9539,
		7147
	],
	"./1/Spectate/SecondaryMenu.layout.js": [
		97680,
		9539,
		2003
	],
	"./31/Kambi/SecondaryMenu.layout.js": [
		38185,
		9539,
		4391
	],
	"./31/Poker/SecondaryMenu.layout.js": [
		38342,
		9539,
		796
	],
	"./31/Spectate/SecondaryMenu.layout.js": [
		78059,
		9539,
		8068
	],
	"./58/Spectate/SecondaryMenu.layout.js": [
		39885,
		9539,
		2719
	],
	"./75/Kambi/SecondaryMenu.layout.js": [
		66881,
		9539,
		6719
	],
	"./75/Spectate/SecondaryMenu.layout.js": [
		97550,
		9539,
		4724
	],
	"./76/Kambi/SecondaryMenu.layout.js": [
		81061,
		9539,
		9108
	],
	"./76/Spectate/SecondaryMenu.layout.js": [
		5089,
		9539,
		3327
	],
	"./8/Poker/SecondaryMenu.layout.js": [
		23323,
		9539,
		8838
	],
	"./8/Spectate/SecondaryMenu.layout.js": [
		65881,
		9539,
		3800,
		3022
	],
	"./81/Kambi/SecondaryMenu.layout.js": [
		68634,
		9539,
		2522
	],
	"./81/Spectate/SecondaryMenu.layout.js": [
		85447,
		9539,
		1845
	],
	"./84/Kambi/SecondaryMenu.layout.js": [
		45614,
		9539,
		4635
	],
	"./84/Spectate/SecondaryMenu.layout.js": [
		16140,
		9539,
		7484
	],
	"./86/Spectate/SecondaryMenu.layout.js": [
		41529,
		9539,
		5290
	],
	"./87/Spectate/SecondaryMenu.layout.js": [
		88894,
		9539,
		8919
	],
	"./88/Spectate/SecondaryMenu.layout.js": [
		93507,
		9539,
		1288
	],
	"./89/Spectate/SecondaryMenu.layout.js": [
		84560,
		9539,
		7709
	],
	"./90/Spectate/SecondaryMenu.layout.js": [
		27186,
		9539,
		5883
	],
	"./91/Spectate/SecondaryMenu.layout.js": [
		71917,
		9539,
		9774
	],
	"./92/Spectate/SecondaryMenu.layout.js": [
		29860,
		9539,
		7253
	],
	"./94/Spectate/SecondaryMenu.layout.js": [
		58521,
		9539,
		8439
	],
	"./95/Spectate/SecondaryMenu.layout.js": [
		71636,
		9539,
		5738
	],
	"./96/Poker/SecondaryMenu.layout.js": [
		91694,
		9539,
		3545
	],
	"./96/Spectate/SecondaryMenu.layout.js": [
		45780,
		9539,
		3800,
		2593
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 21871;
module.exports = webpackAsyncContext;